import * as C from 'actions/constants';

export const blankState = {
  data: [],
  loading: false,
};

const AnswerIdentifiersReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_ANSWER_IDENTIFIERS: {
      return { ...state, loading: true };
    }
    case C.LOAD_ANSWER_IDENTIFIERS_SUCCESS: {
      const { data } = action;
      return { ...state, data, loading: false };
    }
    case C.LOAD_ANSWER_IDENTIFIERS_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export default AnswerIdentifiersReducer;
